<template>
  <div class="chart-wrap" ref="chartWrap" />
</template>
<script>

import { Chart } from '@/utils/g2'
import { formatPercent } from '@/utils/strUtil'
export default {
  name: 'FrontPieChart',
  props: {
    chartHeight: {
      type: Number,
      default: 400
    },
    chartData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    chartData(newVal) {
      this.initChart(newVal)
    }
  },
  created() {
    this.chart = null
    this.initChart(this.chartData)
  },
  beforeDestroy() {
    this.destroyChart()
  },
  methods: {
    initChart(data = []) {
      const { chartWrap } = this.$refs
      if (chartWrap) {
        if (this.chart) {
          this.updateChart(data)
        } else {
          this.renderChart(chartWrap, data)
        }
      } else {
        this.$nextTick(() => {
          this.initChart(data)
        })
      }
    },
    renderChart(container, data = []) {
      this.chart = new Chart({
        container,
        autoFit: true,
        width: 500,
        height: this.chartHeight,
        padding: [20, 130, 30, 0]
      })
      this.chart.data(data)
      this.chart.scale('value', {
        formatter(val) {
          return formatPercent(val)
        }
      })
      this.chart.tooltip({
        showTitle: false,
        domStyles: {
          'g2-tooltip': {
            width: '220px',
            padding: '8px 12px'
          },
          'g2-tooltip-title': {
            display: 'none'
          },
        },
        itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>'
      })
      this.chart.legend({
        position: 'right',
        offsetX: -20,
        itemName: {
          style: () => {
            return {
              fill: '#666', // 文本的颜色
              fontSize: 14
            }
          },
          itemName: {
            formatter: (text) => {
              const oitem = data.find(item => item.name === text)
              return `${text}    ${formatPercent(oitem.value)}`
            }
          }
        }
      })
      this.chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.6
      })
      this.chart.interval().adjust('stack').position('value').color('name', ['#4f6dfb', '#a996f7', '#d6d8fb'])
        .tooltip('name*value', function(name, value) {
          return {
            name,
            value: formatPercent(value)
          }
        })
      this.chart.render()
    },
    updateChart(data = []) {
      this.chart.legend({
        position: 'right',
        offsetX: -20,
        itemName: {
          style: () => {
            return {
              fill: '#666', // 文本的颜色
              fontSize: 14
            }
          },
          formatter: (text) => {
            const oitem = data.find(item => item.name === text)
            return `${text}    ${formatPercent(oitem.value)}`
          }
        }
      })
      this.chart.changeData(data)
    },
    destroyChart() {
      if (this.chart) {
        this.chart.destroy()
        this.chart = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  height: 400px;
}
</style>
